export default "__VITE_ASSET__gr504Vxi__"